import React from "react";
import { FC } from "react";
import { useMemo } from "react";
import { getData } from "country-list";
import BootstrapInput from "../../../../../../../components/BootstrapInput";
import Autocomplete from "../../../../../../../components/Autocomplete";
import DatePicker from "../../../../../../../components/DatePicker";
import Field from "../../../../../../../components/Field";
import { GENDER } from "../../../../../types";

const Student: FC = () => {
  const countries = useMemo(
    () =>
      getData().sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
      ),
    [],
  );

  return (
    <>
      <Field
        required
        fullWidth
        type="text"
        name="name"
        label="Full Name"
        placeholder="Full Name"
        component={BootstrapInput}
      />
      <Field
        required
        autoOk
        fullWidth
        name="studentProfile.birth_date"
        label="Birth Date"
        component={DatePicker}
        placeholder="Birth Date"
        animateYearScrolling
      />
      <Field
        required
        fullWidth
        name="studentProfile.gender"
        label="Gender"
        options={GENDER}
        placeholder="Gender"
        component={Autocomplete}
      />
      <Field
        required
        fullWidth
        name="studentProfile.country"
        label="Country"
        options={countries}
        placeholder="Country"
        component={Autocomplete}
      />
      <Field
        required
        fullWidth
        type="text"
        name="studentProfile.city"
        label="City"
        placeholder="City"
        component={BootstrapInput}
      />
      <Field
        required
        fullWidth
        name="studentProfile.citizenship"
        label="Citizenship"
        options={countries}
        placeholder="Citizenship"
        component={Autocomplete}
      />
    </>
  );
};

export default React.memo(Student);
